export default {
  selectStudentActivity: '/admission-service/admission/student/selectStudentActivity',
  admissionTextDescription: '/admission-service/admission/lookup/selectLookupItemByCode'
}



// WEBPACK FOOTER //
// ./src/config/home/index.js